import { action } from 'mobx';

import { AppManager, Variables } from 'core/index';

import { ProfileConnManager } from 'apps/profile/main/connManager';
import { ProjectConnManager } from 'apps/project/connManager';
import { StoryConnManager } from 'apps/story/main/appManager';
import { ThreadConnManager } from 'apps/forum/main/appManager';

// import { InitiativeOverviewQuery } from "apps/initiative/gql/index";
import { InitiativeMembersQuery } from 'apps/initiative/gql/index';
import { InitiativeCommunityProfileProjectsQuery } from 'apps/project/gql';
import { InitiativeStoriesQuery } from 'apps/story/gql';

export class InitiativeOverviewManager extends AppManager {
  constructor(parent, init = {}, options) {
    super(parent, init, options);
    this.variables = new Variables({
      membersCount: () => {
        if (this.membersConn.arrayApp.length === 0) {
          return this.membersConn.initialBatchSize;
        }
        return this.membersConn.batchSize;
      },
      membersCursor: () => this.membersConn.endCursor,
      membersSortBy: () => this.membersConn.sortBy,
      projectsCount: () => this.projectsConn.variables.batchSize,
      projectsCursor: () => null,
      projectsSortBy: () => this.projectsConn.sortBy,
      storiesCount: () => {
        if (
          this.storiesConn.arrayApp.length > this.storiesConn.initialBatchSize
        ) {
          return this.storiesConn.batchSize;
        }
        return this.storiesConn.initialBatchSize;
      },
      storiesCursor: () => null,
      storiesSortBy: () => this.storiesConn.sortBy,
      threadCursor: () => this.threadsConn.endCursor,
      threadSortBy: () => this.threadsConn.sortBy,
      threadBatchSize: () => this.threadsConn.batchSize,
    });

    this.membersConn = new ProfileConnManager(this, {
      sortBy: 'recent',
      sortOptions: [],
      initialBatchSize: 6,
      batchSize: 18,
      loadMoreQuery: InitiativeMembersQuery,
    });
    this.projectsConn = new ProjectConnManager(this, {
      sortBy: 'recent',
      initialBatchSize: 3,
      sortOptions: [],
      loadMoreQuery: InitiativeCommunityProfileProjectsQuery,
    });
    this.storiesConn = new StoryConnManager(this, {
      sortBy: 'recent',
      sortOptions: [],
      initialBatchSize: 2,
      loadMoreQuery: InitiativeStoriesQuery,
    });
    this.threadsConn = new ThreadConnManager(this, {
      slug: init.params.get('initiative'),
      initialBatchSize: 5,
      sortOptions: [],
    });
    this.variables.onChange(['slug'], this.HandleNewSlug);
  }

  @action
  HandleNewSlug = () => {
    this.membersConn.Reset();
    this.projectsConn.Reset();
    this.storiesConn.Reset();
    this.threadsConn.Reset();
    this.NewInitiativeOverviewQuery();
  };

  @action
  NewInitiativeOverviewQuery = () => {
    this.membersConn.loadMore();
    this.projectsConn.loadMore();
    this.storiesConn.loadMore();
    this.threadsConn.loadMore();
  };
}
